import config from "config";

export const ROUND_FIELDS = `
id
startDate
fxRate
fundingUsd @include(if: $isAuth)
fundingLocal @include(if: $isAuth)
type
status
source @include(if: $isAuth)
vertical
organization
isConfirmed
organizationHasRound {
  id
  entityType
  inClassification(where:{vertical: ${config.VERTICAL}}) @include(if: $isAuth) {
    id
    name
    vertical
    childOf {
      id
      name
    }
  }
  verticalProfiles {
    id
    vertical
    entity {
      id
      name
      city      
      employeeRange
      founded
      inCountry {
        name
        region {
          id
          name
        }
      }
      logo
      verticalProfiles {
        entityTypeProfiles {
          entityType
        }
      }
    }
  }
}
investors @include(if: $isAuth) {    
  ofType {
    id
    name
  }
  verticalProfiles {
    entity {
      id
      name
    }
  }
  investedInConnection {
    edges {
      properties {
        isLead
      }
      node {
        id
      }
    }
  }
}
lastUpdatedBy @include(if: $isAdmin)
updatedAt
createdAt
isGovernment
`;
